module.exports = __webpack_public_path__ + "static/logo-7ad013dff398528a054285ff6460756a.svg";